import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import RequireAdmin from './components/RequireAdmin';
import AdminLayout from './components/AdminLayout';

import Login       from './pages/Login';
import Dashboard   from './pages/Dashboard';
import Categories  from './pages/Categories';
import Products    from './pages/Products';
import Orders      from './pages/Orders';
import Inquiries   from './pages/Inquiries';
import Users       from './pages/Users';
import Banners     from './pages/Banners';
import Brands      from './pages/Brands';
import SiteContent from './pages/SiteContent';

import './styles/global.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
            <Route index          element={<Dashboard />} />
            <Route path="banners"    element={<Banners />} />
            <Route path="brands"     element={<Brands />} />
            <Route path="site-content" element={<SiteContent />} />
            <Route path="categories" element={<Categories />} />
            <Route path="products"   element={<Products />} />
            <Route path="orders"     element={<Orders />} />
            <Route path="orders/:id" element={<Orders />} />
            <Route path="inquiries"  element={<Inquiries />} />
            <Route path="users"      element={<Users />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
